export default "__VITE_ASSET__DL4vgZF7__"